import React from 'react';
import { IApiService, PagingRequest } from './base';
import { FinancialAccount } from './accounting/interfaces';
import { ListFinancialAccountsRequest } from './accounting/requests';
import { IApiListResponse } from './policies/new/service';

export interface IAccountingService {
  listFinancialAccounts( paging: PagingRequest ): Promise<IApiListResponse<FinancialAccount>>;
}

export class AccountingService implements IAccountingService {
  protected api: IApiService;

  constructor( api: IApiService ) {
    this.api = api;
  }

  async listFinancialAccounts( paging: PagingRequest ): Promise<IApiListResponse<FinancialAccount>> {
    const response = await this.api.request( new ListFinancialAccountsRequest( paging ) );

    return response;
  }
}

export const AccountingServiceContext: React.Context<IAccountingService> = React.createContext(
  undefined as any,
);

export const useAccountingService = (): IAccountingService => {
  return React.useContext( AccountingServiceContext );
};

